enum RoleEnum {
  SUPERADMIN = 'superadmin',
  ADMIN = 'admin',
  OPERATOR = 'operator',
  CUSTOMER = 'customer',
  CAPTAIN = 'captain'
}

export default RoleEnum;
